/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import DataVaxiomEmployerForm from 'DesignSystem/DataVaxiomEmployerForm/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/DataVaxiomPatientInsuranceAssignForm/Content/Employer/Options/Edit/Content/Content"
  
}) {
  return (<React.Fragment
>
<DataVaxiomEmployerForm
  viewPath={`${viewPath}/DataVaxiomEmployerForm`}
/>
{children}
</React.Fragment>)
}